import * as stylex from '@stylexjs/stylex'
import { type ComponentPropsWithoutRef } from 'react'

const styles = stylex.create({
  root: {
    gap: 16,
    display: 'flex',
    flexDirection: 'column',
  },
})

export interface CartListProps extends ComponentPropsWithoutRef<'div'> {
  rootStyle?: stylex.StyleXStyles
}

export const CartList = (props: CartListProps) => {
  const { rootStyle, ...rest } = props
  return (
    <div {...stylex.props(styles.root, rootStyle)} {...rest} />
  )
}
